import { openDB } from 'idb';

const dbPromise = openDB('json-cache-db', 1, {
  upgrade(db) {
    db.createObjectStore('json-files');
  },
});

// Function to set items in IndexedDB
export const setItemInIndexedDB = async (key, value) => {
  const db = await dbPromise;
  await db.put('json-files', value, key);
};

// Function to get items from IndexedDB
export const getItemFromIndexedDB = async (key) => {
  const db = await dbPromise;
  return db.get('json-files', key);
};

// Function to set cached item with expiration
export const setCachedItemWithExpiry = async (key, value, expiryInMinutes = 30) => {
  const timestampedValue = { value, expiry: Date.now() + expiryInMinutes * 60000 };
  await setItemInIndexedDB(key, timestampedValue);
};

// Function to get cached item with expiration check
export const getCachedItemWithExpiry = async (key) => {
  const cachedData = await getItemFromIndexedDB(key);
  if (cachedData && Date.now() < cachedData.expiry) {
    return cachedData.value;
  }
  return null; // Return null if expired or missing
};
